import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "grid", "row", "rowTemplate",
    "labelLeftField", "labelRightField",
    "labelsContainer", "labelLeftPreview", "labelRightPreview"
  ];
  static values = {
    questionPartId: String,
    size: Number
  };

  updateLabels() {
    const labelLeft = this.labelLeftFieldTarget.value;
    const labelRight = this.labelRightFieldTarget.value;
    const labelsPresent = labelLeft.trim() !== '' || labelRight.trim() !== '';

    this.labelLeftPreviewTarget.textContent = labelLeft;
    this.labelRightPreviewTarget.textContent = labelRight;
    this.labelsContainerTarget.classList.toggle('hidden', !labelsPresent);
  }

  changeSize(event) {
    const newSize = parseInt(event.currentTarget.dataset.value, 10);
    if (isNaN(newSize) || newSize < 1 || newSize > 11) return;

    const visibleRows = this.rowTargets.filter(r => !r.classList.contains('hidden'));
    const currentSize = visibleRows.length;
    const delta = newSize - currentSize;

    if (delta > 0) {
      this._grow(currentSize, delta);
    } else if (delta < 0) {
      this._shrink(Math.abs(delta));
    }

    this.sizeValue = newSize;
  }

  _grow(currentSize, delta) {
    const hiddenRows = this.rowTargets.filter(r => r.classList.contains('hidden'));

    for (let i = 0; i < delta; i++) {
      const hiddenRow = hiddenRows[i];
      if (hiddenRow) {
        this._showRow(hiddenRow, currentSize + i);
      } else {
        this._cloneRow(currentSize + i);
      }
    }
  }

  _shrink(count) {
    const visibleRows = this.rowTargets.filter(r => !r.classList.contains('hidden'));

    for (let i = 0; i < count; i++) {
      const row = visibleRows[visibleRows.length - 1 - i];
      const altId = row.dataset.alternativeId;

      if (altId) {
        const destroyField = row.querySelector('[data-destroy-field]');
        if (destroyField) {
          destroyField.value = '1';
        }

        row.querySelectorAll('input[type="text"]').forEach(input => {
          input.disabled = true;
        });

        row.classList.add('hidden');
      } else {
        row.remove();
      }
    }
  }

  _showRow(row, newIndex) {
    const destroyField = row.querySelector('[data-destroy-field]');
    if (destroyField) {
      destroyField.value = 'false';
    }

    row.querySelectorAll('input[type="text"]').forEach(input => {
      input.disabled = false;
    });

    row.classList.remove('hidden');

    const positionField = row.querySelector('input[name*="[position]"]');
    if (positionField) positionField.value = newIndex;
  }

  _cloneRow(index) {
    const template = this.rowTemplateTarget;
    const clone = template.content.cloneNode(true).firstElementChild;
    const uniqueKey = Date.now() + index;

    clone.querySelectorAll('input').forEach(input => {
      input.name = input.name.replace('NEW_IDX', uniqueKey);
    });

    const positionField = clone.querySelector('input[name*="[position]"]');
    if (positionField) {
      positionField.value = index;
    }

    const textField = clone.querySelector('input[name*="[text]"]');
    const label = index + 1;

    if (textField) {
      textField.value = label;
    }

    const labelEl = clone.querySelector('.js-scale-option-template');
    if (labelEl) {
      labelEl.textContent = label;
    }

    this.gridTarget.appendChild(clone);
  }
}
